import { h, JSX } from 'preact'
import { PartiResultat } from '../../../../domain'

import styles from './Legend.module.css'

type Props = { message?: JSX.Element | string; resultater: PartiResultat[] }

export function Legend({ message, resultater }: Props) {
  return (
    <div class={styles.legend}>
      {message ? (
        <div class={styles.text}>
          <span>{message}</span>
        </div>
      ) : null}
      <ul class={styles.items}>
        {resultater.map(resultat => {
          return (
            <li class={styles.item}>
              <span
                class={styles.dot}
                style={{
                  background: resultat.parti.farge
                }}
              />
              <span>{resultat.parti.kortNavn}</span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
